export default __webpack_public_path__ + "static/media/slide-2.4429d98e.png";